import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { SidebarContainerComponent } from './se-sidebar/sidebar-container.component';
import { SidebarComponent } from './se-sidebar/sidebar.component';
import { CloseSidebarDirective } from './se-sidebar/close.directive';

import { SeAccordionComponent } from './se-accordion/se-accordion.component';
import { SeCheckedListBoxComponent } from './se-checkedlistbox/se-checkedlistbox.component';
import { SeCheckedItemComponent } from './se-checkedlistbox/se-checkeditem.component';
import { SeToggleButtonComponent } from './se-togglebutton/se-togglebutton.component';
import { SeImageButtonComponent } from './se-imagebutton/se-imagebutton.component';
import { SeStateButtonComponent } from './se-statebutton/se-statebutton.component';
import { SeClickOutsideDirective } from './se-clickoutside.directive';
import { SeDomChangeDirective } from './se-dom-change.directive';
import { SeComboBoxComponent } from './se-combobox/se-combobox.component';
import { SeSliderButtonComponent } from './se-sliderbutton/se-sliderbutton.component';
import { SeFlatPanelComponent } from './se-flatpanel/se-flatpanel.component';
import { SeSpinnerComponent } from './se-spinner/se-spinner.component';
import { SeModalWindowComponent } from './se-modalwindow/se-modalwindow.component';
import { SeModalDialogComponent } from './se-modaldialog/se-modaldialog.component';
import { SeContextMenuComponent } from './se-contextmenu/se-contextmenu.component';
import { SeContextMenuDirective } from './se-contextmenu/se-contextmenu.directive';
import { SeFloatingLabelComponent } from './se-floating-label/se-floating-label.component';

import { SeUiLayoutModule } from '../se-ui-layout/se-ui-layout.module';

import { SeCheckboxComponent } from './se-checkbox/se-checkbox.component';
import { SeDurationComponent } from './se-duration/se-duration.component';
import { SeLabelComponent } from './se-label/se-label.component';
import { SeNotificationsComponent } from './se-notifications/se-notifications.component';
import { SeModalDialogNotificationsComponent } from './se-modaldialog-notifications/se-modaldialog-notifications.component';
import { SeFullScreenComponent } from './se-fullscreen/se-fullscreen.component';
import { SeSpriteComponent } from './se-sprite/se-sprite.component';

import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { DateTimePipe } from './pipes/datetime.pipe';
import { SwitchMultiCasePipe } from './pipes/switch-multi-case.pipe';

import { SeAutoFocusDirective } from '../se-ui-utilities/se-auto-focus.directive';

@NgModule({
    declarations: [
        SidebarContainerComponent,
        SidebarComponent,
        CloseSidebarDirective,
        SeAccordionComponent,
        SeCheckedListBoxComponent,
        SeCheckedItemComponent,
        SeToggleButtonComponent,
        SeImageButtonComponent,
        SeStateButtonComponent,
        SeClickOutsideDirective,
        SeDomChangeDirective,
        SeComboBoxComponent,
        SeSliderButtonComponent,
        SeFlatPanelComponent,
        SeSpinnerComponent,
        SeModalWindowComponent,
        SeModalDialogComponent,
        SeContextMenuComponent,
        SeContextMenuDirective,
        SeCheckboxComponent,
        SeLabelComponent,
        SeNotificationsComponent,
        SeModalDialogNotificationsComponent,
        SeFullScreenComponent,
        SeSpriteComponent,
        DateTimePipe,
        SwitchMultiCasePipe,
        SeAutoFocusDirective,
        SeFloatingLabelComponent,
        SeDurationComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PdfViewerModule,
        TranslateModule,
        SeUiLayoutModule,
        // Material
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSliderModule,
        MatToolbarModule,
        MatTooltipModule,
    ],
    exports: [
        SidebarContainerComponent,
        SidebarComponent,
        CloseSidebarDirective,
        SeAccordionComponent,
        SeCheckedListBoxComponent,
        SeCheckedItemComponent,
        SeToggleButtonComponent,
        SeImageButtonComponent,
        SeStateButtonComponent,
        SeClickOutsideDirective,
        SeDomChangeDirective,
        SeComboBoxComponent,
        SeSliderButtonComponent,
        SeSliderButtonComponent,
        SeFlatPanelComponent,
        SeSpinnerComponent,
        SeModalWindowComponent,
        SeModalDialogComponent,
        SeContextMenuComponent,
        SeContextMenuDirective,
        SeCheckboxComponent,
        SeLabelComponent,
        SeNotificationsComponent,
        SeModalDialogNotificationsComponent,
        SeFullScreenComponent,
        SeSpriteComponent,
        DateTimePipe,
        SwitchMultiCasePipe,
        SeAutoFocusDirective,
        SeFloatingLabelComponent,
        SeDurationComponent,
    ],
})
export class SeUiControlsModule {}
